import { itemValue } from "./itemValue";
import { Output, EventEmitter } from '@angular/core';
import { groupItem } from "./groupItem";
import {isNullOrUndefined} from '../../../_helpers';

export class menuItem{
    Code:string ="";
    Title:string ="";
    // Type de menu (2:Mono, 1:MultiSelectable, 3:Action)
    Checkable:menuType = menuType.Mono;
    GroupItems:Array<groupItem> = new Array<groupItem>();
    MultipleGroupSelected: boolean = true;
    Visible:boolean = true;
    //si monoselection, sur refresh il masque la div, permet si plus de record que d affiché de repositionner
    //true ou null
    MonoRefresh:boolean|null = null;
    /**
     * Nombre maximum d'éléments sélectionnables dans un menu multi-sélection.
     * Null signifie qu'il n'y a pas de limite.
     * compléter MultiMaxSelectableTltp avec le texte à afficher lorsque la sélection maximale est atteinte.
     */
    MultiMaxSelectable:number|null = null;
      /**
     * Nombre maximum d'éléments sélectionnables dans un menu multi-sélection.
     * à partir duquel on affiche une alerte de sélection maximale.
     * compléter MultiMaxSelectableTltp avec le texte à afficher lorsque la sélection maximale est atteinte.
     */
    MultiMaxAlertSelectable:number|null = null;
    /**
     * Le texte affiché en tooltip sur selection maximale atteinte.
     */
    MultiMaxSelectableTltp:string|null = null;



   /**
     * On ordonne l'objet(ASC) les menus présents dans chaque groupes présents
     * @param blIncludeGroups Indique si OUI on ordonne également les groupes selon le titre
     */
    public Order(blIncludeGroups:boolean)
    {
        if( this.GroupItems!= null && this.GroupItems.length>0)
        {
            if(blIncludeGroups && this.GroupItems.length>1)
            {
                this.GroupItems=  this.GroupItems.sort(function(a,b){
                    return (isNullOrUndefined(a.Title))?-1:(isNullOrUndefined(b.Title))?1: (a.Title.toLowerCase()<b.Title.toLowerCase())?-1:(a.Title.toLowerCase()>b.Title.toLowerCase())?1:0;
                  })
            }
             this.GroupItems.forEach(r=>r.OrderItems());

        }
    }

    /**
     * retourne la liste des données depuis index de groupe (commence à 0)
     * @param _iNdxGrp 
     * @returns null group existe pas ou sans items sinon liste
     */
    public GetItemsGroup(_iNdxGrp:number):itemValue[]|null{

        if(this.GroupItems.length>_iNdxGrp && this.GroupItems[_iNdxGrp]?.Items){
            return this.GroupItems[_iNdxGrp]?.Items;
        }
        return null;
    }

    /**
     * initialise le nombre maximum d'éléments sélectionnables dans un menu multi-sélection, mecanisme de blocage de la sélection.
     * 
     * @param max  le nombre maximum d'éléments sélectionnables mécaniquement
     * @param alertMax  le nombre d'éléments à partir duquel on affiche une alerte de sélection maximale SI il dispose bien de plus que  max dans ce menu
     * @param tooltip  le texte à afficher lorsque la sélection maximale est atteinte
     */
    public SetMaxSelectable(max: number|null, alertMax: number|null, tooltip: string|null){
        this.MultiMaxSelectable = max;
        this.MultiMaxAlertSelectable = alertMax;
        this.MultiMaxSelectableTltp = tooltip;
    }
}
export enum menuType {
    //dans le sous menu
    MultiSelectable = 1,
    Mono = 2,
    Action = 3,
}

